import React, {cloneElement, useMemo} from "../../../__snowpack__/pkg/react.js";
import {Badge, Tabs as AntdTabs, Tooltip} from "../../../__snowpack__/pkg/antd.js";
import classNames from "../../../__snowpack__/pkg/classnames.js";
import TabPane from "./TabPane.js";
import {useControllableValue} from "../../../__snowpack__/pkg/ahooks.js";
import {isFunction, isObject} from "../../../__snowpack__/pkg/lodash.js";
export const TabsContext = React.createContext(null);
export default function Tabs(props) {
  const {tabs, children, ...tabsProps} = props;
  const [activeKey, setActiveKeyKey] = useControllableValue(props, {
    valuePropName: "activeKey",
    defaultValuePropName: "defaultActiveKey"
  });
  let tabPanes;
  let uniqueRenderedContent;
  if (isFunction(children)) {
    uniqueRenderedContent = children(activeKey);
  } else {
    tabPanes = children;
  }
  if (Array.isArray(tabs)) {
    tabPanes = tabs.map((tab) => /* @__PURE__ */ React.createElement(TabPane, {
      key: tab.tabKey,
      ...tab
    }));
  }
  tabPanes = Array.isArray(tabPanes) ? [...tabPanes] : [tabPanes];
  tabPanes = tabPanes.map((pane) => {
    const {tab, count, render, children: _children, tip} = pane.props;
    return cloneElement(pane, {
      tab: tip ? /* @__PURE__ */ React.createElement(Tooltip, {
        placement: "top",
        title: tip
      }, /* @__PURE__ */ React.createElement("div", null, tab, /* @__PURE__ */ React.createElement(Badge, {
        showZero: true,
        overflowCount: Number.MAX_SAFE_INTEGER,
        ...isObject(count) ? count : {},
        count: isObject(count) ? count.count : count
      }))) : /* @__PURE__ */ React.createElement("div", null, tab, /* @__PURE__ */ React.createElement(Badge, {
        showZero: true,
        overflowCount: Number.MAX_SAFE_INTEGER,
        ...isObject(count) ? count : {},
        count: isObject(count) ? count.count : count
      }))
    }, !!uniqueRenderedContent ? void 0 : render?.() ?? _children);
  });
  const values = useMemo(() => ({activeKey}), [activeKey]);
  return /* @__PURE__ */ React.createElement(TabsContext.Provider, {
    value: values
  }, /* @__PURE__ */ React.createElement(AntdTabs, {
    ...tabsProps,
    onChange: (activeKey2) => {
      setActiveKeyKey(activeKey2);
    },
    className: classNames("page-container-tabs", {
      "page-container-tabs-unique-render": !!uniqueRenderedContent
    }, props.className)
  }, tabPanes), uniqueRenderedContent && /* @__PURE__ */ React.createElement("div", {
    className: classNames("page-container-tabs-unique-tabpane", "ant-tabs-tabpane", "ant-tabs-tabpane-active"),
    role: "tabpanel",
    tabIndex: 0
  }, tabs?.find(({tabKey}) => tabKey === activeKey)?.render?.() ?? uniqueRenderedContent));
}
Tabs.TabPane = TabPane;
